import React from "react";
import { doLog, hasValue } from "../../shared/utility";

// import classes from './Logo.css';
let logoWidth = "140";
let logoHeight = "90";

const logo = (props) => {
  if (doLog()) console.log("[logo] logoWidth:", props.logoWidth);
  if (hasValue(props.logoWidth) && props.logoWidth.length > 0) logoWidth = props.logoWidth;
  if (hasValue(props.logoHeight) && props.logoHeight.length > 0) logoHeight = props.logoHeight;
  return (
    <img
      src={props.logoPath}
      alt="logo"
      width={logoWidth}
      height={logoHeight}
    />
  );
};

export default logo;
